import { TrackSegment } from '../types'

export enum TrackSegmentBehavior {
  Drag = 'drag',
  CutLeft = 'cutLeft',
  CutRight = 'cutRight',
  Select = 'select',
}

export const isDisabledBehavior = (
  segment: TrackSegment,
  behavior: TrackSegmentBehavior,
): boolean => {
  return segment.disabled || segment.behavior?.[behavior] === false
}

export const isEnabledBehavior = (
  segment: TrackSegment,
  behavior: TrackSegmentBehavior,
): boolean => {
  return !isDisabledBehavior(segment, behavior)
}
